<template>
  <div
    class="group p-2 relative flex flex-col justify-center items-center"
  >
    <!-- Mobile: no hover, always-visible actions -->
    <template v-if="isMobile">
      <div class="flex flex-col items-center w-full">
        <button
          v-if="file.mime === 'image/jpeg' || file.mime === 'image/png'"
          type="button"
          class="w-full flex justify-center"
          @click="showFullImage = true"
        >
          <img
            :src="imageData"
            class="max-h-32 max-w-full w-auto object-contain rounded-md"
          >
        </button>

        <div
          v-else
          class="flex flex-col items-center w-full"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-7 h-7 mb-2">
    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
  </svg>
        </div>

        <p
          v-if="file.mime !== 'image/jpeg' && file.mime !== 'image/png'"
          class="font-semibold mt-2 text-center break-all w-4/5"
        >
          {{ file.fileName }}
        </p>

        <button
          type="button"
          class="mt-3 btn-icon btn-icon-red btn-icon--bg-red"
          @click="deleteMedia"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-5 h-5">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>
      </div>
    </template>

    <!-- Desktop: hover to show delete -->
    <template v-else>
      <button
        v-if="file.mime === 'image/jpeg' || file.mime === 'image/png'"
        type="button"
        @click="showFullImage = true"
      >
        <img
          :src="imageData"
          class="max-h-40 max-w-40"
        >
      </button>

      <div
        v-else
        class="flex flex-col items-center w-full"
      >
        <button
          type="button"
          class="w-6 h-6 hidden group-hover:block"
          @click="deleteMedia"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="btn-icon btn-icon-red w-6 h-6 group-hover:text-red-600 fill-red-300">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
        </button>

        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 group-hover:hidden">
    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
  </svg>

        <p class="font-semibold mt-2 text-nowrap">
          {{ file.fileName }}
        </p>
      </div>

      <button
        v-if="file.mime === 'image/jpeg' || file.mime === 'image/png'"
        type="button"
        class="absolute w-6 h-6 hidden group-hover:block"
        @click="deleteMedia"
      >
        <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="btn-icon btn-icon-red w-6 h-6 group-hover:text-red-600 fill-red-300">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
      </button>
    </template>

    <span
      v-if="error"
      class="text-red-600 text-sm"
    >{{ error }}</span>

    <Teleport
      v-if="showFullImage"
      to="#modals"
    >
      <div
        class="absolute"
        tabindex="0"
      >
        <div class="fixed z-[60] flex justify-center items-center m-4 inset-0">
          <img
            :src="imageData"
            class="max-h-screen p-10"
          >
        </div>

        <button
          type="button"
          @click="showFullImage = false"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="h-10 w-10 text-white fixed z-[60] top-0 right-0 m-5">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>
        </button>

        <div
          class="opacity-75 fixed inset-0 z-50 bg-black"
        />
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import useScreenSize, { ScreenSize } from '@/composables/useScreenSize';
import { computed, ref } from 'vue';

const props = defineProps<{
  file: UploadedFile;
  error?: string;
}>();

const emits = defineEmits<{
  (e: 'delete');
}>();

const { screenSize } = useScreenSize();

const isMobile = computed(() => {
  if(!screenSize.value) {
    return false;
  }

  return screenSize.value <= ScreenSize.MD;
});

const deleteMedia = () => {
  emits('delete');
};

const showFullImage = ref(false);
const imageData = ref();

if(props.file.mime === 'image/jpeg' || props.file.mime === 'image/png') {
  const reader = new FileReader();

  // Use this to create a display thumbnail for upload
  reader.onload = (ev) => {
    imageData.value = ev.target.result;
  };

  reader.readAsDataURL(props.file.fileBlob);
}
</script>

<style scoped></style>
